import { Injectable } from '@angular/core';
import { TScannedInfoWithScanLockDetails } from '@monorepo/types';
import { EventUtil } from '@monorepo/utils';
import { Subject } from 'rxjs';
import { BluetoothCommonService } from './bluetooth-common.service';

@Injectable({
  providedIn: 'root',
})
export class HIDService {
  private bluetoothHIDManager: any;
  scannedInfoEmitter = new Subject<TScannedInfoWithScanLockDetails>();
  constructor(private bluetoothCommonService: BluetoothCommonService) {}

  init(window: any) {
    window.listenBluetoothHIDEvent = this.listenBluetoothHIDEvent.bind(this);
    this.bluetoothHIDManager = (() => {
      class BluetoothHIDManager {
        private static newTagTriggerKey = 'Backquote';
        private static completionKey = 'Enter';
        private canBeBluetoothHIDDeviceEvent = false;
        private bluetoothHIDEventsArrayBuffer: any[] = [];
        private timeout: any = null;
        private doRead1DBarcode = false;
        private static stopCurrentEventBehaviour(event: any) {
          event.preventDefault();
          event.stopPropagation();
        }
        private clearTimeoutIfNeeded() {
          if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
          }
        }

        isCanBeBluetoothHIDDeviceEvent() {
          return this.canBeBluetoothHIDDeviceEvent;
        }
        addToBuffer(event: any) {
          const push = () => {
            this.bluetoothHIDEventsArrayBuffer.push(event);
            BluetoothHIDManager.stopCurrentEventBehaviour(event);
          };
          let storeEvent = this.isCanBeBluetoothHIDDeviceEvent();
          if (!storeEvent) {
            //For new tags we have Backtick as indentifier
            console.log('addToBuffer called');
            if (this.doRead1DBarcode || event.key === 'V' || event.key === '_') {
              this.canBeBluetoothHIDDeviceEvent = true;
              storeEvent = true;
              console.log(
                'addToBuffer storeEvent and canBeBluetoothHIDDeviceEvent => ',
                this.canBeBluetoothHIDDeviceEvent,
              );
            }
          }
          if (storeEvent) {
            push();
            this.clearTimeoutIfNeeded();
            this.timeout = setTimeout(() => {
              this.reset();
            }, 2000);
          }
          return storeEvent;
        }

        bufferIsComplete() {
          return (
            this.bluetoothHIDEventsArrayBuffer[this.bluetoothHIDEventsArrayBuffer.length - 1].key ===
            BluetoothHIDManager.completionKey
          );
        }

        getFilteredBufferString() {
          return this.bluetoothHIDEventsArrayBuffer
            .map((event) => {
              //For Backtick event.key is 'Dead'
              return event.code == BluetoothHIDManager.newTagTriggerKey ? '`' : event.key;
            })
            .filter((key) => key.length === 1)
            .join('');
        }

        reset() {
          this.canBeBluetoothHIDDeviceEvent = false;
          this.bluetoothHIDEventsArrayBuffer = [];
          this.clearTimeoutIfNeeded();
        }
      }
      return new BluetoothHIDManager();
    })();
  }

  private listenBluetoothHIDEvent(event: any) {
    console.log('listenBluetoothHIDEvent called');
    this.bluetoothHIDManager.addToBuffer(event);
    if (this.bluetoothHIDManager.isCanBeBluetoothHIDDeviceEvent()) {
      if (this.bluetoothHIDManager.bufferIsComplete()) {
        console.log('listenBluetoothHIDEvent bufferIsComplete');
        const qrCodeRawString = this.bluetoothHIDManager.getFilteredBufferString();
        this.emitHIDInputData(qrCodeRawString);
        this.bluetoothHIDManager.reset();
      }
    }
  }

  getScannedInfoEmitterSubscription() {
    return this.scannedInfoEmitter.asObservable();
  }

  emitHIDInputData(byteString: string) {
    // user can scan globaly also to search tag history, if lock details source is SEARCH_TAG_HISTORY or isLocled = true ignore emitted scanner data  wherever you have subscribed this
    this.scannedInfoEmitter.next({ byteString, lockDetails: this.bluetoothCommonService.getScanLockDetails() });
  }

  //Set this to true to read any 1D Barcode genrated by Factories outside of our system (i.e not in V3 or keyvalue format)
  enableReadFor1DBarcode(isEnabled: boolean) {
    this.bluetoothHIDManager.doRead1DBarcode = isEnabled;
  }
}
